
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Bado_classification_of_Montessori_fracture",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Bado_classification_of_Montessori_fracture.vue